import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { FormContextState } from './form-context-slice';

const $formContext = (state: RootState): FormContextState => state.formContext;

export const $formUrl = createSelector($formContext, (formContext) => formContext.formUrl);
